import { displayNotification } from '../state/ui'

/*
 * The Cast Application Framework session API.
 *
 * `sendMessage` here takes two arguments and reports failure by rejecting;
 * the four-argument form with success/error callbacks belongs to the older
 * `chrome.cast.Session` API. Four call sites used to pass that form against a
 * CAF session, so both callbacks were silently dropped -- the "Cast is ready"
 * toast never fired, failures were never surfaced, and the rejected promise
 * went unhandled. Centralising it here keeps that from drifting apart again.
 */
interface CastSession {
  sendMessage(namespace: string, data: unknown): Promise<unknown>
}

const NAMESPACE = 'urn:x-cast:tv.iziplay.chromecast'

function currentSession(): CastSession | null {
  const cast = (window as any).cast
  if (!cast?.framework) return null

  return cast.framework.CastContext.getInstance().getCurrentSession() ?? null
}

/**
 * Sends a message to the active cast session, if there is one.
 *
 * @param data    payload for the iziplay receiver app
 * @param notify  whether to raise a toast on success/failure
 * @returns whether a session was there to send to
 */
export function castSend(data: unknown, notify = false) {
  const session = currentSession()
  if (!session) return false

  session.sendMessage(NAMESPACE, data).then(
    () => {
      if (notify) displayNotification('Cast is ready', 'success')
    },
    () => {
      if (notify) displayNotification('Problem with cast', 'error')
    }
  )

  return true
}
